import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import * as _ from 'underscore';

import { forwardRef, AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { EmitterService } from '../../../../core/utility/services/emitter.service';

export const DROPDOWN_CONTROL_VALUE_ACCESSOR: any = {
	multi: true,
	provide: NG_VALUE_ACCESSOR,
	// tslint:disable-next-line: no-use-before-declare
	useExisting: forwardRef(() => CustomDropdownComponent)
};

@Component({
	providers: [DROPDOWN_CONTROL_VALUE_ACCESSOR],
	selector: 'app-custom-dropdown',
	styleUrls: ['./custom-dropdown.component.css'],
	templateUrl: './custom-dropdown.component.html'
})
export class CustomDropdownComponent extends AngularMultiSelect implements OnInit, AfterViewInit {
	public selectedList: any[] = [];
	@Input() content: string;
	@Input() checkForAdvertisers: any;
	@ViewChild('advertisersDropDown') private elTitle: ElementRef;

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		let getDemoAdvertisers = false;
		if (this.checkForAdvertisers) {
			getDemoAdvertisers = this.checkDemoAdvertisers(this.data);
			if (!getDemoAdvertisers) {
				this.setDataForCheckbox();
			}
		}
	}
	advtDropdownClick(item: any, i: any, event: any): void {
		const maxLength = 10;
		const exists = _.find(this.selectedList, (num: any): boolean => {
			return num === item.id;
		});
		if (this.selectedItems.length < maxLength || exists) {
			this.selectedList.push(item.id);
			this.onItemClick(item, i, event);
		}
	}
	CustomtoggleSelectAll(): void {
		// tslint:disable-next-line: prefer-for-of
		for (let i = 0; i < this.elTitle.nativeElement.children[0].children.length; i++) {
			this.elTitle.nativeElement.children[0].children[i].children[0].checked = false;
		}
		this.selectedItems.length = 0;
		EmitterService.get('ADVERTISERS').emit(this.selectedItems);
	}

	checkDemoAdvertisers(data: any): boolean {
		let returnType = false;
		for (let i = 0; i < this.data.length; i++) {
			if (data[i].is_demo) {
				returnType = true;
				break;
			}
		}
		return returnType;
	}

	setDataForCheckbox(): void {
		if (this.data.length < 10) {
			// tslint:disable-next-line: prefer-for-of
			for (let i = 0; i < this.elTitle.nativeElement.children[0].children.length; i++) {
				this.elTitle.nativeElement.children[0].children[i].children[0].checked = true;
			}
		}
		if (this.data.length > 10) {
			// tslint:disable-next-line: prefer-for-of
			for (let i = 0; i < this.elTitle.nativeElement.children[0].children.length; i++) {
				this.elTitle.nativeElement.children[0].children[i].children[0].checked = false;
			}
			this.selectedItems.length = 0;
		}
	}
}
